import React from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { urls } from '..';
import { useIsDateSection } from './IsDateSectionProvider';
import { MAX_SELECTIONS, useTournamentsSelections } from './TournamentsSelectionsProvider';
import useIsLiveSection from './useIsLiveSection';
import { removeMultipleSlashes } from '../data/sport-utils';
import { getLabel } from '../data/labels';

export default function OpenSelectionsButton() {
    const navigate = useNavigate();
    const params = useParams();
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();
    const tournamentsSelections = useTournamentsSelections();

    if (tournamentsSelections.ids.size === 0) {
        return null;
    }

    function handleClick() {
        const ids = Array.from(tournamentsSelections.ids).join(',');
        if (isLiveSection) {
            navigate(removeMultipleSlashes(`${urls.base}/${urls.live.base}/${urls.live.torneo}/${ids}`));
        } else if (isDateSection) {
            navigate(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${params.date}/${params.sportId}/${params.aggId}/${ids}`));
        } else {
            navigate(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${ids}`));
        }
    }

    function handleReset(e) {
        e.stopPropagation();
        tournamentsSelections.reset();
    }

    return (
        <>
            <div className="fixed bottom-48 left-0 right-0 w-max mx-auto h-fit flex items-center justify-center">
                <div className="px-2 py-1 flex items-center space-between bg-cs2 text-lg text-cs3 rounded-lg shadow-sm shadow-shadow" onClick={handleClick}>
                    <span>{getLabel('general.open_selected')}</span>
                    <i className="bi-trash ml-1 pl-1 border-l border-l-cc4" onClick={handleReset}></i>
                </div>
            </div>
            {tournamentsSelections.ids.size === MAX_SELECTIONS &&
                <div className="fixed bottom-[100px] left-0 right-0 w-full h-fit flex items-center justify-center">
                    <div className="px-2 py-1 flex items-center space-between bg-[#3b3c43] opacity-60 text-md text-[#ffd307] rounded-lg shadow-sm shadow-shadow" onClick={handleClick}>
                        <span>{getLabel('error.selection_limit_reached')}</span>
                    </div>
                </div>
            }
        </>
    );
}
